export const COMMON_MODAL_ON_OK = 'COMMON_MODAL_ON_OK'
export const COMMON_MODAL_ON_CANCEL = 'COMMON_MODAL_ON_CANCEL'
export const COMMON_MODAL_ON_HIDE = 'COMMON_MODAL_ON_HIDE'
export const COMMON_MODAL_SHOW = 'COMMON_MODAL_SHOW'
export const COMMON_MODAL_DISMISS = 'COMMON_MODAL_DISMISS'
